<template>
  <mdb-select
    outline
    search
    class="no-margin-select mt-3"
    label="Agent"
    :visible-options="20"
    :disabled="disabled"
    v-model="agentsModel"
    @getValue="setAgent($event)"
  />
</template>

<script>
import { mapState, mapActions } from 'vuex'
import {orderType} from '../utils'
import {OrderTypes} from '../enums'
import {mdbSelect} from 'mdbvue'

export default {
  name: 'CalcControlsAgentSelect',
  data () {
    return {
      agentsModel: []
    }
  },
  computed: {
    ...mapState('calc', {
      agents: state => state.data.agents,
      agent: state => state.query.agent,
      linked: state => state.linked,
      clone: state => state.clone
    }),
    disabled: function () {
      return (this.clone && this.clone.context === OrderTypes.AGENT) ||
        (this.linked && orderType(this.linked) === OrderTypes.AGENT)
    }
  },
  methods: {
    ...mapActions('calc', ['setAgent']),
    calculateModel () {
      this.agentsModel = [
        {text: 'Any Agent', value: null, selected: this.agent === null},
        ...this.agents.map(ag => {
          return {text: ag, value: ag, selected: ag === this.agent}
        })
      ]
    }
  },
  mounted () {
    this.calculateModel()
  },
  watch: {
    agent: {
      handler: function () {
        this.calculateModel()
      }
    },
    agents: {
      deep: true,
      handler: function () {
        this.calculateModel()
      }
    }
  },
  components: {
    mdbSelect
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CalcControlsAgentSelect.vue